// frontend/packages/business-console/src/components/content/PublishConfirmDialog.jsx
//
// Confirmation dialog before publishing changes to the live website.
// Shows what will happen and gives the user a chance to preview first.

import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function PublishConfirmDialog({ open, onClose, onConfirm, publishing }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Publish to your live website?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Your saved changes will go live and be visible to everyone who visits your website.
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          This usually takes 1-2 minutes. You can always restore to a previous version if needed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={publishing}>Cancel</Button>
        <Button
          variant="contained"
          color="success"
          onClick={onConfirm}
          disabled={publishing}
          sx={{ fontWeight: 900 }}
        >
          {publishing ? "Publishing..." : "Yes, publish now"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
